import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AdminLayout from './components/layouts/AdminLayout';
import ShopLayout from './components/layouts/ShopLayout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import QRResolvePage from './pages/QRResolvePage';
import ShopCheckinPage from './pages/ShopCheckinPage';
import UnauthorisedPage from './pages/UnauthorisedPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminQRPage from './pages/admin/AdminQRPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import AdminShopDetailPage from './pages/admin/AdminShopDetailPage';
import AdminShopsPage from './pages/admin/AdminShopsPage';
import ShopBatchesPage from './pages/shop/ShopBatchesPage';
import ShopDashboardPage from './pages/shop/ShopDashboardPage';
import ShopOrdersPage from './pages/shop/ShopOrdersPage';
import ShopSettingsPage from './pages/shop/ShopSettingsPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorised" element={<UnauthorisedPage />} />
        <Route path="/qr/:token" element={<QRResolvePage />} />
        <Route path="/shop/checkin/:shopId" element={<ShopCheckinPage />} />

        {/* Admin routes — nested under /admin with persistent AdminLayout */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="shops" element={<AdminShopsPage />} />
          <Route path="shops/:shopId" element={<AdminShopDetailPage />} />
          <Route path="qr-codes" element={<AdminQRPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* Shop owner routes — nested under / with persistent ShopLayout */}
        <Route
          path="/"
          element={
            <ProtectedRoute role="shop_owner">
              <ShopLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<ShopDashboardPage />} />
          <Route path="orders" element={<ShopOrdersPage />} />
          <Route path="batches" element={<ShopBatchesPage />} />
          <Route path="settings" element={<ShopSettingsPage />} />
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
